export type AdminTab = "members" | "prompts" | "sessions";

const TABS: AdminTab[] = ["members", "prompts", "sessions"];

/** Sessions tab state carried in the URL so Back and shared links restore it. */
export interface SessionsTabState {
  user: string | null;
  page: number;
  q: string;
}

export function parseAdminTab(params: URLSearchParams): AdminTab {
  const tab = params.get("tab");
  return TABS.includes(tab as AdminTab) ? (tab as AdminTab) : "members";
}

export function parseSessionsState(params: URLSearchParams): SessionsTabState {
  const page = Number(params.get("page"));
  return {
    user: params.get("user") || null,
    page: Number.isInteger(page) && page >= 1 ? page : 1,
    q: params.get("q") ?? "",
  };
}

/** Query string (no leading "?") for the Sessions tab, omitting defaults. */
export function sessionsSearch(state: SessionsTabState): string {
  const params = new URLSearchParams({ tab: "sessions" });
  if (state.user) params.set("user", state.user);
  if (state.page > 1) params.set("page", String(state.page));
  if (state.q) params.set("q", state.q);
  return params.toString();
}
